import { render } from "./CardChallengeResultDeclarationCompleted.vue?vue&type=template&id=a5bebdb2&scoped=true"
import script from "./CardChallengeResultDeclarationCompleted.vue?vue&type=script&lang=js"
export * from "./CardChallengeResultDeclarationCompleted.vue?vue&type=script&lang=js"

import "@/css/components/card-challenge-result-declaration-completed.css?vue&type=style&index=0&id=a5bebdb2&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5bebdb2"]])

export default __exports__